import React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Modal, OverlayTrigger, Popover } from "react-bootstrap";
import { toast } from "react-toastify";
import { UserHover } from "Components";
import { getFirstLetterOfName } from "Utils";
import { newAuthService } from "Service/Axios";
import { UPDATE_MULTIPLE_TASK_DECISION_URL } from "Constant/api";

export const RecommendationDetails = ({
  show,
  recommendationDetails,
  fieldDetailsRender,
  toggle,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  // Handler
  const onUpdateDecision = async (taskDecision) => {
    try {
      const payload = {
        gid: [recommendationDetails.gid],
        decision: taskDecision,
      };
      const response = await newAuthService(
        UPDATE_MULTIPLE_TASK_DECISION_URL,
        "POST",
        payload
      );
      if (response.status && response.data.success) {
        toast.success(t("common.messages.notification.success.updateStatus"));
        toggle();
      } else {
        toast.error(response.message);
      }
    } catch (error) {
      if (error.response && error.response.data) {
        toast.error(error.response.data.message);
      }
    }
  };

  return (
    <Modal
      show={show}
      onHide={toggle}
      centered
      backdrop="static"
      keyboard={false}
    >
      <Modal.Header closeButton>
        <h3 className="modal-title fs-5" id="exampleModalLabel">
          Recommender
        </h3>
      </Modal.Header>
      <Modal.Body className="p-0">
        <div className="p-3 border-bottom">
          <OverlayTrigger
            placement="bottom"
            overlay={
              <Popover className="max-w-unset">
                <UserHover user={recommendationDetails} />
              </Popover>
            }
          >
            <div className="d-flex align-items-center">
              <div className="me-2 w-16 h-16 flex-none rounded-circle bg-grey-100 position-relative overflow-hidden">
                {recommendationDetails.userDetails?.photoURL ? (
                  <img
                    alt={`${recommendationDetails.userDetails?.firstName}-${recommendationDetails.userDetails?.lastName}`}
                    className="w-100 h-100 object-fit-cover"
                    src={recommendationDetails.userDetails?.photoURL}
                  />
                ) : (
                  getFirstLetterOfName(recommendationDetails.userDetails)
                )}
              </div>

              <div className="new-av-details">
                <h4 className="text-sm font-semibold">
                  {recommendationDetails.userDetails?.firstName}{" "}
                  {recommendationDetails.userDetails?.lastName}
                </h4>
                <ul className="m-0 p-0 list-unstyled text-xs d-flex flex-column row-gap-1">
                  <li className="d-flex align-items-start text-break">
                    <i className="bx bx-envelope mt-1 me-1"></i>{" "}
                    {recommendationDetails.userDetails?.email}
                  </li>
                </ul>
              </div>
            </div>
          </OverlayTrigger>
          {/* <div className="hover-effect">
            <div className="new-avater d-flex align-items-center">
              <div className="mb-2 position-relative">
                <div className="me-2 w-16 h-16 rounded-circle bg-grey-100 position-relative overflow-hidden">
                  {recommendationDetails.userDetails?.photoURL ? (
                    <img
                      alt={`${recommendationDetails.userDetails?.firstName}-${recommendationDetails.userDetails?.lastName}`}
                      className="w-100 h-100 object-fit-cover"
                      src={recommendationDetails.userDetails?.photoURL}
                    />
                  ) : (
                    getFirstLetterOfName(recommendationDetails.userDetails)
                  )}
                </div>
              </div>
              <div className="new-av-details">
                <h4 className="text-sm font-semibold">
                  {recommendationDetails.userDetails?.firstName}{" "}
                  {recommendationDetails.userDetails?.lastName}
                </h4>
                <ul className="m-0 p-0 list-unstyled text-xs d-flex flex-column row-gap-1">
                  <li className="d-flex align-items-center">
                    <i className="bx bx-envelope me-1"></i>{" "}
                    {recommendationDetails.userDetails?.email}
                  </li>
                </ul>
              </div>
            </div>
            <UserHover user={recommendationDetails.userDetails} />
          </div> */}
        </div>
        <div className="p-3 recommender-show-content border-bottom">
          <ul className="m-0 p-0 list-unstyled text-sm d-flex flex-column row-gap-1">
            {recommendationDetails.fieldDetails?.length > 0 &&
              recommendationDetails.fieldDetails
                .filter((fieldDetail) => fieldDetail.name !== "Full Name")
                .map((fieldDetail, fieldIndex) => (
                  <li
                    className="py-1 d-flex align-items-center font-medium"
                    key={fieldIndex.toString()}
                  >
                    {fieldDetailsRender(fieldDetail)}
                  </li>
                ))}
          </ul>
        </div>
        {recommendationDetails.requestreftext ? (
          <div className="p-3">
            <h5 className="h6 fot-bold">Request for a reference</h5>
            <p className="text-sm">{recommendationDetails.requestreftext}</p>
          </div>
        ) : null}
      </Modal.Body>
      <Modal.Footer>
        <div className="d-flex gap-2 mx-auto w-100">
          {/* <button
            className="btn btn-success py-2 px-4 col"
            onClick={() => onUpdateDecision("Approve")}
          >
            Approve
          </button>
          <button
            className="btn btn-danger py-2 px-4 col"
            onClick={() => onUpdateDecision("Decline")}
          >
            Decline
          </button> */}
          {recommendationDetails.buttons?.length > 0 &&
            recommendationDetails.buttons.map((btn) => (
              <button
                key={btn.gid}
                className="btn py-2 px-4 col"
                style={{
                  backgroundColor: btn.backgroundColor,
                  color: btn.fontColor,
                }}
                onClick={() => {
                  if (btn.type === "Form") {
                    navigate(btn.url, {});
                  } else {
                    onUpdateDecision(btn.name);
                  }
                }}
              >
                {btn.name}
              </button>
            ))}
        </div>
      </Modal.Footer>
    </Modal>
  );
};
